import { motion } from 'framer-motion';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import ProgramListItem from './ProgramListItem';


function ProgramList({cols, programs, basePath, isPublic, organizationUniqueName,
                      noLink, menu, emptyMessage, isSearch}) {
  const mdWidth= cols === 'single' ? 12 : 4;
  const smWidth= cols === 'single' ? 12 : 6;

  if (!programs) {
    return null;
  }

  if (programs.length === 0) {
    return (
      <div className="flex flex-1 items-center justify-center h-full">
        <Typography color="text.secondary" variant="h6">
          {emptyMessage}
        </Typography>
      </div>
    );
  }


  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1, transition: { delay: 0.2 } }}
      className="flex flex-col flex-auto w-full max-h-full"
    >
        <Grid container spacing={2} alignItems="stretch" className="w-full m-0 p-0">
          {programs.map((program) => (
			<Grid key={program.id} item xs={12} sm={smWidth} md={mdWidth}>
            	<ProgramListItem key={program.id} 
            	                program={program} 
            	                basePath={basePath} 
            	                isSearch={isSearch}
                                 isPublic={isPublic}
                                 organizationUniqueName={organizationUniqueName}
                                 noLink={noLink}
            	                menu={menu}/>
            </Grid>
          ))}
        </Grid>
         
    </motion.div>
  );
}

export default ProgramList;
